import type {User, UserIdentity} from '@supabase/supabase-js';

/**
 * Prefer a user-set CDN avatar_url, then OAuth identity pictures.
 * Keep in sync with web-mp-account `resolveAccountAvatarUrl`.
 */
export function resolveAccountAvatarUrl(
  user: User | null | undefined,
  identities: UserIdentity[] | null | undefined = [],
): string | undefined {
  const metaUrl = String(user?.user_metadata?.['avatar_url'] || user?.user_metadata?.['picture'] || '')
    .trim();
  if (metaUrl) {
    return metaUrl;
  }

  for (const identity of identities ?? []) {
    const data = identity.identity_data ?? {};
    const url = String(data['avatar_url'] || data['picture'] || '').trim();
    if (url) {
      return url;
    }
  }

  return undefined;
}
